<template>
    <app-modal
        :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal"
        modal-size="large"
    >
        <template slot="header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span><app-icon :name="'x'" /></span>
            </button>
        </template>

        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form
                ref="form"
                class="mb-0"
                :class="{ 'loading-opacity': preloader }"
                :data-url="selectedUrl ? `destinations/${inputs.id}` : `destinations`"
            >
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="destination-name">{{ $t('name') }}</label>
                            <app-input id="destination-name" v-model="inputs.name" type="text" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="destination-description">{{ $t('description') }}</label>
                            <app-input id="destination-description" v-model="inputs.description" type="text" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="destination-latitude">{{ $t('latitude') }}</label>
                            <app-input id="destination-latitude" v-model="inputs.latitude" type="decimal" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="destination-longitude">{{ $t('longitude') }}</label>
                            <app-input id="destination-longitude" v-model="inputs.longitude" type="decimal" />
                        </div>
                    </div>
                    <div class="col-12">
                        <p class="text-muted mb-0">{{ $t('coordinates_recommended_for_eta') }}</p>
                    </div>
                </div>
            </form>
        </template>

        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">
                {{ $t('save') }}
            </button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'DestinationAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
            default: 'destinations-table',
        },
    },
    data() {
        return {
            modalId: 'destination-add-edit-modal',
            modalTitle: this.$t('new_destination'),
            inputs: {
                name: '',
                description: '',
                latitude: '',
                longitude: '',
            },
        };
    },
    methods: {
        submit() {
            this.save(this.inputs);
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
            this.$store.dispatch('getDestinations');
        },
        afterSuccessFromGetEditData(response) {
            this.inputs = {
                ...response.data,
                latitude: response.data.latitude ?? response.data.lat ?? '',
                longitude: response.data.longitude ?? response.data.lng ?? '',
            };
            this.preloader = false;
        },
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>
